import ColorWrapper from "Components/ColorWrapper";
import { InsuranceCoverage } from "Store/interfaces/products/coverage";
import { radioTrackId } from "Utils/analytics";
import { isDefined } from "Utils/functions";
import React from "react";
import { CoverageCardHeader, HeaderWrapper, StyledInput } from "./styled";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  type: "radio" | "checkbox";
  value: InsuranceCoverage;
  label: string;
  labelDetails?: React.ReactNode;
  hideRadioButton?: boolean;
  removePaddingLeft?: boolean;
  disabled?: boolean;
  padding?: string;
}

export const SelectableCoverageCard = ({
  id,
  type,
  value,
  label,
  labelDetails,
  hideRadioButton,
  removePaddingLeft,
  disabled,
  checked,
  children,
  padding,
  ...rest
}: Props): React.ReactElement => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const selected = isDefined(disabled) && disabled ? false : checked;
  const inputId = radioTrackId(id);

  return (
    <ColorWrapper
      coverageDetailsCard
      dynamicInsuranceDetailsCard
      selected={selected}
      disabled={disabled}
      padding={padding}
    >
      <CoverageCardHeader onClick={() => inputRef.current?.click()}>
        <HeaderWrapper removePaddingLeft={removePaddingLeft}>
          <StyledInput
            {...rest}
            onClick={(e) => e.stopPropagation()}
            checked={checked}
            value={value}
            type={type}
            ref={inputRef}
            hidden={hideRadioButton}
            disabled={disabled}
            id={inputId}
            data-trackid={inputId}
          />
          <label htmlFor={inputId}>{label}</label>
        </HeaderWrapper>
        {labelDetails}
      </CoverageCardHeader>
      {children}
    </ColorWrapper>
  );
};
